<template>
  <div class="">
    <zt-modal :active="activeModal" @close="closeModal" max-width="32rem" :z-index="49">
      <div v-if="uploading" class="modal-content-wrapper">
        <div class="add-file-modal">
          <StepUploadFiles />
        </div>
        <div v-show="error" class="flex justify-start  items-center p-4 mb-2 bg-certs-error">
          <zt-icon name="exclamation-circle-solid" class="info-icon mr-2 "  />
          <p class="text-zt-base font-normal self-center">
            {{ error }}
          </p>
        </div>
        <div class="flex justify-around w-100 pb-8">
          <zt-button data-vs-button="active-step" class="ml-1 " color="disabled" @click="closeModal"
            style="color: #707070 !important">{{$t('message.addFileModal.cancel')}}</zt-button>
          <zt-button class="ml-1 buttonPrimaryProperties text-white" :loader="loading" :disabled="disabled"
            @click="finishUpload">{{$t('message.addFileModal.send')}}</zt-button>
        </div>
      </div>
      <div v-else class="flex p-20 flex-col items-center">
        <div class="pt-10 pb-2">
          <div class="changed-icon flex items-center justify-center flex-none ">
            <zt-icon name="check" />
          </div>
        </div>
        <span class=" text-lg text-gray-600 font-medium py-10">
          {{$t('message.addFileModal.success')}}
        </span>
        <zt-button data-vs-button="close-step" @click="closeModal"
          class="ml-1 mt-10 buttonPrimaryProperties text-white">{{$t('message.addFileModal.close')}}</zt-button>
      </div>
    </zt-modal>
  </div>
</template>

<script>
import StepUploadFiles from './StepUploadFiles'
import _ from 'lodash'
import UploadFiles from "@/apiClient/UploadFiles";
import Licenses from "@/apiClient/Licenses"
import { state as importedState, mutations as importedMutations } from '@/modules/Licenses/components/Observables/useLicenseHistory.js'

export default {
  components: {
    StepUploadFiles
  },
  props: {
    activeModal: {
      type: Boolean,
      default: false
    },
    licenceId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      licenses: Licenses,
      uploading: true,
      loading: false,
      metadata: {},
      error: '',
      state:  importedState,
      mutations: importedMutations
    }
  },
  created() {
    this.initializeUploadMetaData();
  },
  computed: {
    disabled() {
      return !importedState.request.documents.length;
    }
  },
  watch: {
    activeModal(newVal) {
      if (newVal) {
        this.initializeUploadMetaData();
      }
    }
  },
  methods: {
    closeModal() {
      this.resetData();
      if (!this.uploading) {
        this.$emit('closeModalandUpdateList');
      }
      this.$emit('close');
    },
    async requestLicenseFiles(documents) {
    this.loading = true;
    this.error = null; 
    try {
      const json = { ...this.state.uploadFilesMetaData.json, files: documents };
      await this.uploadFiles.sendNewDocsToTemplate(this.state.uploadFilesMetaData.id, json, documents);
      this.uploading = false;
      this.$emit('updateList');
    } catch (error) {
      this.error = this.$t('message.errorReference.SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_ERROR'); 
    } finally {
      this.loading = false;
    }
  },

    resetData() {
      this.uploadFiles = new UploadFiles();
      this.mutations.cleanUploadFilesMetaData();
      this.mutations.cleanConfig();
      this.mutations.cleanRequest();
    },
    finishUpload() {
    try {
      const documents = this.state.request.documents;
      if (documents && documents.length > 0) {
        this.requestLicenseFiles(documents);
      }
    } catch (error) {
      this.error = this.$t('message.errorReference.SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_ERROR'); 
    }
  },
    initializeUploadMetaData() {
      this.error = '';
      this.uploading = true;
      this.resetData();  
      this.mutations.setUploadFilesMetaData({
        id: this.licenceId,
        id_template: 1,
        json: {
          name: "GEN",
          alias: "Generico",
          files: [{ hash: "", name: "Generico", alias: "Generico", order: 10, value: "", mimeType: "", mandatory: true }],
          max_files: 20,
          min_files: 1,
          version_name: "CE1",
          version_number: 1
        },
        name: "CERTIFICADOS DE LICENCIAS"
      });
    }
  }
}
</script>
<style scoped>
.grey-background {
  background-color: #ebebeb;
}

.add-file-modal {
  display: flex;
  padding: 41px !important;
  min-height: 40rem;
  align-items: center;
}

.buttonPrimaryProperties {
  color: white !important;
}

.changed-icon {
  border-radius: 50%;
  background: #54CAA6;
  width: 82px;
  height: 82px;
  font-size: 40px;
  color: #FFF;
}

::v-deep .zt-modal-button-close {
  color: black !important;
}
.error-icon {
  color: #def3ff;
  background: #ec1101;
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem;
}
.zt-icon-exclamation-circle-solid {
  font-size: x-large;
  color: red;
}
.bg-certs-error>p {
  color: #ec1101 !important;
  opacity: 1 !important;
}
.bg-certs-error {
  background: #ffe2de 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #ffe2de;
}
.modal-content-wrapper {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>